import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { OrderService } from 'src/app/core/services/order.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { User } from 'src/app/shared/model/user.model';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    StepperComponent
  ]
})
export class ProjectsComponent implements OnInit, AfterViewInit {
  requestTypeEnum = RequestType;
  controller = '';

  submitError = false;
  modalContent?: NgbModalRef;
  spinner = false;
  steps = new Map<string, boolean>();
  user!: User;
  landing2 = false;

  constructor(
    private orderService: OrderService,
    public dialog: MatDialog,
    private storageService: StorageService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  onSelectionAuthorizers(event: { controller: string; authorizer: string }) {
    this.controller = event.controller;
  }

  sendRequest(newRequestData: any) {
    this.spinner = true;
    this.orderService.sendProjects(newRequestData).subscribe({
      next: () => {
        this.spinner = false;
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('newRequestOk'),
            redirect: true,
            list: true,
            theme: 'ligth'
          }
        });
      },
      error: () => {
        this.spinner = false;
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('newRequestKO'),
            close: true,
            theme: 'ligth'
          }
        });
      }
    });
  }

  setSteps() {
    this.steps.set('vehicle-finder', false);
    this.steps.set('request-info', true);
    this.steps.set('approvers', true);
    this.steps.set('car-config', false);
    this.steps.set('replacementvehicle', false);
    this.steps.set('additionalInfo', true);
  }
}
